var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row p-0 m-0"},[_c('div',{ref:"mm",staticClass:"col-md-10",style:({ height: _vm.windowHeight + 'px' }),attrs:{"id":"mymap"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }